/**************************************************************************************************/
/*   File: /src/app/shared/models/local.document.info.ts                                          */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { LocalDocumentStatusEnum } from '../enums';

/**
 * The local document info
 */
export class LocalDocumentInfo {
    /**
     * The creation date
     */
    creationDate: Date;
    /**
     * True if is internal user
     */
    isInternalUser: boolean;
    /**
     * The status
     */
    status: LocalDocumentStatusEnum;
    /**
     * The user id
     */
    userId: number;
}